module.exports = __webpack_public_path__ + "static/media/file-upload.753f100e.svg";